module.exports = __webpack_public_path__ + "img/7.45aba4f5.png";